import React, { useState } from "react";
import { IListObj } from "../types/genericTypes";
import "../../assets/scss/components/generic/overflowButton.scss";

export interface IOverflowButtonProps {
	defaultValue?: number | string; // default selected value
	dropdownOptions: Array<IListObj>; // list of all options in dropdown
	onSelect: (id: string | number, data?: any) => void; // the function to be called onSelect
	showBuySellColor?: boolean; // shows colours if options are buy and sell; buy = green, sell = red
	onHover?: boolean;
	data?: any;
}

const OverflowButton: React.FC<IOverflowButtonProps> = (props: IOverflowButtonProps) => {
	/**
	 * state and function for isDropdownOpen
	 * selectedValue type is boolean
	 * setSelectedValue(boolean)
	 */
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	//if dropdown shown on hover
	//have to be closed after option selection
	//this state used to handle this scenario
	const [isOptionSelected, setIsOptionSelected] = useState(false);

	/**
	 * called when user selects an option
	 * @param id id of the selected option
	 * @returns onSelect prop passed from parent
	 */
	function optionSelected(id: string | number) {
		setIsDropdownOpen(false);
		setIsOptionSelected(true);
		return props.onSelect(id, props.data);
	}
	return (
		<div
			className={"overflow_button " + (isDropdownOpen ? " open" : isOptionSelected ? " close" : "") + (props.onHover ? " showOnHover" : "")}
		>
			{props.dropdownOptions.length > 0 && (
				<button
					className="ellipsis_button ddTgl"
					onClick={() => setIsDropdownOpen(true)}
					onMouseOver={() => isOptionSelected && setIsOptionSelected(false)}
				>
					{/* show three dots */}
					<span className="dot" />
					<span className="dot" />
					<span className="dot" />
				</button>
			)}
			{/* when dropdown is open show overlay and content -> only on click */}
			{isDropdownOpen && <div className="dropdown_overlay" onClick={() => setIsDropdownOpen(false)} />}
			<div className="dd_cont">
				{/* Overlay covers the whole screen. When overlay is clicked, close the dropdown. */}

				{/* Dropdown list */}
				<ul className="dropdown_content dtl_popup_action">
					{props.dropdownOptions.map((option) => {
						let color = "black";
						if (props.showBuySellColor) {
							if (option.display.toLowerCase() === "buy") {
								color = "green";
							} else if (option.display.toLowerCase() === "sell") {
								color = "red";
							}
						}

						return (
							<li className={"dropdown_item dtl_popup_action " + color} key={option.value} onClick={() => optionSelected(option.value)}>
								{option.display}
							</li>
						);
					})}
				</ul>
			</div>
			{/* )} */}
		</div>
	);
};

export default OverflowButton;
